import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AnnouncementTab = ({ sessionData }) => {
  const [announcementType, setAnnouncementType] = useState('participant-list');
  const [generatedText, setGeneratedText] = useState('');

  const announcementTypeOptions = [
    { value: 'participant-list', label: '참가자 명단 공지' },
    { value: 'payment-reminder', label: '결제 안내' },
    { value: 'bracket-announcement', label: '대진표 공지' },
    { value: 'session-reminder', label: '세션 리마인더' },
    { value: 'cancellation', label: '취소 안내' }
  ];

  const generateAnnouncement = () => {
    let text = '';
    
    switch (announcementType) {
      case 'participant-list':
        text = `📋 ${sessionData?.title} 참가자 명단\n\n`;
        text += `📅 일시: ${new Date(sessionData.date)?.toLocaleDateString('ko-KR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long'
        })} ${sessionData?.startTime}\n`;
        text += `📍 장소: ${sessionData?.venue}\n`;
        text += `👥 참가 인원: ${sessionData?.participants?.filter(p => p?.status === 'confirmed')?.length}/${sessionData?.capacity}명\n\n`;
        text += `✅ 확정 참가자:\n`;
        sessionData?.participants?.filter(p => p?.status === 'confirmed')?.forEach((p, i) => {
            text += `${i + 1}. ${p?.name}${p?.payment === 'paid' ? ' ✓' : ' (미입금)'}\n`;
          });
        text += `\n💰 참가비: 회원 ${sessionData?.pricing?.member?.toLocaleString()}원`;
        if (sessionData?.allowGuests) {
          text += ` / 게스트 ${sessionData?.pricing?.guest?.toLocaleString()}원`;
        }
        text += `\n\n입금 계좌: ${sessionData?.bankInfo?.bankName} ${sessionData?.bankInfo?.accountNumber} (${sessionData?.bankInfo?.accountHolder})`;
        text += `\n입금 마감: ${new Date(sessionData.paymentDeadline)?.toLocaleString('ko-KR')}`;
        break;

      case 'payment-reminder':
        text = `💳 ${sessionData?.title} 결제 안내\n\n`;
        text += `아직 입금하지 않으신 분들은 아래 계좌로 입금 부탁드립니다.\n\n`;
        text += `💰 입금 금액:\n`;
        text += `- 회원: ${sessionData?.pricing?.member?.toLocaleString()}원\n`;
        if (sessionData?.allowGuests) {
          text += `- 게스트: ${sessionData?.pricing?.guest?.toLocaleString()}원\n`;
        }
        text += `\n🏦 입금 계좌:\n`;
        text += `${sessionData?.bankInfo?.bankName} ${sessionData?.bankInfo?.accountNumber}\n`;
        text += `예금주: ${sessionData?.bankInfo?.accountHolder}\n\n`;
        text += `⏰ 입금 마감: ${new Date(sessionData.paymentDeadline)?.toLocaleString('ko-KR')}\n\n`;
        text += `❗ 미입금 시 참가가 취소될 수 있습니다.`;
        break;

      case 'bracket-announcement':
        text = `🎯 ${sessionData?.title} 대진표\n\n`;
        text += `📅 일시: ${new Date(sessionData.date)?.toLocaleDateString('ko-KR')} ${sessionData?.startTime}\n`;
        text += `📍 장소: ${sessionData?.venue}\n\n`;
        text += `대진표는 아래 링크에서 확인하실 수 있습니다:\n`;
        text += `https://picklelink.com/s/${sessionData?.token}\n\n`;
        text += `⏰ 세션 시작 10분 전까지 도착해주세요!`;
        break;

      case 'session-reminder':
        text = `⏰ ${sessionData?.title} 리마인더\n\n`;
        text += `내일 세션이 있습니다!\n\n`;
        text += `📅 일시: ${new Date(sessionData.date)?.toLocaleDateString('ko-KR', {
          month: 'long',
          day: 'numeric',
          weekday: 'long'
        })} ${sessionData?.startTime}\n`;
        text += `📍 장소: ${sessionData?.venue}\n`;
        text += `👥 참가 인원: ${sessionData?.participants?.filter(p => p?.status === 'confirmed')?.length}명\n\n`;
        text += `준비물:\n`;
        text += `- 운동복 및 운동화\n`;
        text += `- 개인 라켓 (대여 가능)\n`;
        text += `- 수건 및 음료\n\n`;
        text += `⏰ 시작 10분 전까지 도착해주세요!`;
        break;

      case 'cancellation':
        text = `❌ ${sessionData?.title} 취소 안내\n\n`;
        text += `불가피한 사정으로 세션이 취소되었습니다.\n\n`;
        text += `📅 취소된 세션: ${new Date(sessionData.date)?.toLocaleDateString('ko-KR')} ${sessionData?.startTime}\n\n`;
        text += `입금하신 참가비는 전액 환불 처리됩니다.\n`;
        text += `환불은 영업일 기준 3-5일 소요됩니다.\n\n`;
        text += `다음 세션에서 뵙겠습니다. 감사합니다.`;
        break;

      default:
        text = '공지 유형을 선택해주세요.';
    }

    setGeneratedText(text);
  };

  const handleCopyText = () => {
    navigator.clipboard?.writeText(generatedText);
    alert('공지 내용이 클립보드에 복사되었습니다.');
  };

  const handleSendToKakao = () => {
    alert('카카오톡 오픈채팅으로 전송 기능이 실행됩니다.');
  };

  return (
    <div className="space-y-6">
      <div className="p-4 md:p-6 bg-card rounded-md border border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4">
          공지 생성
        </h3>

        <div className="space-y-6">
          <Select
            label="공지 유형"
            options={announcementTypeOptions}
            value={announcementType}
            onChange={setAnnouncementType}
            description="생성할 공지의 유형을 선택하세요"
          />

          <Button
            variant="default"
            size="default"
            iconName="FileText"
            iconPosition="left"
            onClick={generateAnnouncement}
            fullWidth
          >
            공지 생성
          </Button>
        </div>
      </div>

      {generatedText && (
        <div className="p-4 md:p-6 bg-card rounded-md border border-border">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              생성된 공지
            </h3>
            
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="Copy"
                onClick={handleCopyText}
              >
                복사
              </Button>
              
              <Button
                variant="default"
                size="sm"
                iconName="Send"
                onClick={handleSendToKakao}
              >
                카카오톡 전송
              </Button>
            </div>
          </div>

          <div className="p-4 bg-muted rounded-md border border-border">
            <pre className="whitespace-pre-wrap text-sm text-foreground font-sans">
              {generatedText}
            </pre>
          </div>

          <div className="mt-4 p-4 bg-accent/10 rounded-md border border-accent/20">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={16} className="text-accent mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">공지 전송 안내</p>
                <p className="text-sm caption text-muted-foreground">
                  생성된 공지를 복사하여 카카오톡 오픈채팅에 붙여넣거나,\n
                  '카카오톡 전송' 버튼을 클릭하여 직접 전송할 수 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {!generatedText && (
        <div className="p-12 text-center bg-muted rounded-md border border-border">
          <Icon name="MessageSquare" size={48} className="mx-auto mb-4 text-muted-foreground" />
          <p className="text-base font-medium text-foreground mb-2">공지가 생성되지 않았습니다</p>
          <p className="text-sm caption text-muted-foreground">
            공지 유형을 선택하고 '공지 생성' 버튼을 클릭하세요
          </p>
        </div>
      )}

      <div className="p-4 md:p-6 bg-card rounded-md border border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4">
          공지 템플릿 가이드
        </h3>

        <div className="space-y-4">
          <div className="p-4 bg-muted rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="Users" size={16} className="text-primary mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">참가자 명단 공지</p>
                <p className="text-sm caption text-muted-foreground">
                  확정된 참가자 목록과 결제 상태를 포함한 공지를 생성합니다.
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 bg-muted rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="DollarSign" size={16} className="text-success mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">결제 안내</p>
                <p className="text-sm caption text-muted-foreground">
                  입금 계좌 정보와 마감 시간을 포함한 결제 안내 공지를 생성합니다.
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 bg-muted rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="Grid3x3" size={16} className="text-accent mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">대진표 공지</p>
                <p className="text-sm caption text-muted-foreground">
                  생성된 대진표 링크와 세션 정보를 포함한 공지를 생성합니다.
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 bg-muted rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="Bell" size={16} className="text-warning mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">세션 리마인더</p>
                <p className="text-sm caption text-muted-foreground">
                  세션 전날 참가자들에게 보낼 리마인더 공지를 생성합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementTab;